import { observer } from "mobx-react-lite";
import { TriangleAlert } from "lucide-react";
import { MyButton } from "./MyButton";
import { MyModal } from "./MyModal";
import { COMMON } from "../../constants/commonText.constants";
import { useTran } from "../../hooks/useTran";

// Confirmation for a destructive action. Asks "delete <name>?" by default;
// `title`, `message` and `confirmLabel` (already translated) reuse the same
// look for other questions, e.g. leaving with unsaved changes.
const DeleteConfirmModal = observer(
  ({
    handleDelete,
    name,
    isDeleteConfirmModalOpen,
    closeDeleteConfirmModal,
    title,
    message,
    confirmLabel,
  }) => {
    const { t } = useTran();

    return (
      <div>
        <MyModal
          isOpen={isDeleteConfirmModalOpen}
          title={title ?? t(COMMON.DELETE_CONFIRMATION)}
          size={"small"}
          isStatic
          footer={
            <div className="flex gap-2 items-center justify-end">
              <MyButton
                variant="secondary"
                onClick={closeDeleteConfirmModal}
                id="deleteModalClose"
              >
                {t(COMMON.CANCEL)}
              </MyButton>
              <MyButton
                variant="destructive"
                id="delete_confirm"
                onClick={handleDelete}
              >
                {confirmLabel ?? t(COMMON.DELETE)}
              </MyButton>
            </div>
          }
        >
          <div className="flex gap-3 py-3 items-center">
            <TriangleAlert className="text-red-600" />
            <span>
              {message ?? (
                <>
                  {t(COMMON.ARE_U_SURE)} <strong>{name}</strong> ?
                </>
              )}
            </span>
          </div>
        </MyModal>
      </div>
    );
  },
);

export default DeleteConfirmModal;
